import React, { useCallback } from 'react'
import { PrefixInput, PrefixInputProps } from '../PrefixInput/PrefixInput'
import { Currency } from '../../../globalTypes'

const currencySymbol = (currency: Currency) => {
  return (0)
    .toLocaleString('en-CA', { style: 'currency', currency, minimumFractionDigits: 0, maximumFractionDigits: 0 })
    .replace(/\d/g, '')
    .trim()
}

export const CurrencyInput: React.FC<Omit<PrefixInputProps, 'prefix' | 'onChange'> & {
  currency?: Currency
  onChange(val: string): void
}> = ({ currency = Currency.CAD, onChange, ...rest }) => {
  const handleChange = useCallback(
    (_: any, value: string) => {
      onChange(value)
    },
    [onChange],
  )
  return <PrefixInput {...rest} onChange={handleChange} prefix={currencySymbol(currency)} />
}
